/* Sticky Header */
const header = document.getElementById("header");
let scrollpos = window.scrollY;

window.addEventListener('scroll', function(){ 
    scrollpos = window.scrollY;
    scrollpos > 40 ? header.classList.add('is-sticky') : header.classList.remove('is-sticky');
});

document.addEventListener('DOMContentLoaded', () => {
    const hamburger = document.querySelector('[data-js="hamburger"]');
    const menu = document.querySelector('[data-js="header-menu"]');
    const html = document.documentElement;

    if (!hamburger || !menu) return;

    hamburger.addEventListener('click', function(e) {
        e.preventDefault();

        const isActive = hamburger.classList.contains('is-active');

        if (isActive) {
            hamburger.classList.remove('is-active');
            menu.classList.remove('is-active');
            html.classList.remove('has-nav-open');
        } else {
            hamburger.classList.add('is-active');
            menu.classList.add('is-active');
            html.classList.add('has-nav-open');
        }
    });
});
